export default "__VITE_ASSET__wSunqQKm__"